import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import {
  GetEmailDtoStatusEnum,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { SignatureStatus } from '../../../common/spdCore/validation/schemas';

export const EmailSendLink = (props: {
  judgmentId: string;
  setRefresh?: () => void;
  signStatus?: string | null | undefined;
}) => {
  const spd = useSpdCore();

  const handleClick = () => {
    spd.emails
      .sendJudgmentByEmail(props.judgmentId, false)
      .then(response => {
        if (response.status !== GetEmailDtoStatusEnum.Sent) {
          alert(`Wystąpił problem z wysłaniem orzeczenia: ${response.info}`);
        }

        if (props.setRefresh) {
          props.setRefresh();
        }
      })
      .catch(async response => {
        const errors = await responseErrors(response as ResponseError);
        alert(`Wystąpił problem z wysłaniem orzeczenia: ${errors}`);
      });
  };

  return (
    <>
      {props.signStatus === SignatureStatus.Signed && (
        <ConfirmationButton
          className="ms-1"
          confirmation="Czy na pewno wysłać dokument pocztą e-mail?"
          variant="btn-info"
          onOK={handleClick}
        >
          <OverlayTrigger
            overlay={
              <Tooltip style={{ position: 'fixed' }}>
                Wyślij pocztą e-mail
              </Tooltip>
            }
          >
            <Icon.SendFill />
          </OverlayTrigger>
        </ConfirmationButton>
      )}
    </>
  );
};
